import * as actions from 'actions';
import byIdMaker from 'reducersMakers/byIdMaker';

export default byIdMaker({
  fetchSuccessTypes: [
    actions.CHAT_QUESTIONNAIRES_RECEIVED
  ],
  updateSuccessTypes: [
   actions.CHAT_QUESTIONNAIRE_UPDATE
  ],
  entityType: 'chatQuestionnaires',
  updateKey: 'chatQuestionnaireId'
});



/** WEBPACK FOOTER **
 ** ./src/members/state/chat/chatQuestionnaires/byId/reducer.js
 **/